import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Images } from 'assets/images';
import ReactFacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';
import { authActions, httpRequestsOnErrorsActions } from 'store';
import { loginProvider } from './types';
import { gapi } from 'gapi-script';
import { useFindError } from 'hooks/useFindError';
import { SOCIAL_LOGIN } from 'store/auth';
import { setStorage } from 'utils/storageHelpers';
import { FacebookIcon, GoogleIcon, SocialMediaIcons } from './styled';

export const SocialLogin = ({ setShowEmailModal }) => {
  const dispatch = useDispatch();

  const [activeProvider, setActiveProvider] = useState();
  const socialLoginError = useFindError(SOCIAL_LOGIN);

  const handleSocialMediaSubmit = (response, provider) => {
    setActiveProvider(provider);
    if (response.accessToken) {
      if (provider === loginProvider.facebook) {
        setStorage('fbAccessToken', response.accessToken);
      }
      const body = {
        accessToken: response.accessToken,
        provider,
      };
      dispatch(authActions.socialLogin(body));
    }
  };
  useEffect(() => {
    gapi.load('client:auth2', () => {
      gapi.auth2.init({ clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID });
    });
  }, []);

  useEffect(() => {
    if (socialLoginError.length && activeProvider === loginProvider.facebook) {
      setShowEmailModal(true);
      dispatch(httpRequestsOnErrorsActions.removeError(SOCIAL_LOGIN));
    }
  }, [socialLoginError.length, activeProvider]);

  return (
    <SocialMediaIcons>
      <ReactFacebookLogin
        appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
        autoLoad={false}
        fields="name,email,picture"
        callback={(response) =>
          handleSocialMediaSubmit(response, loginProvider.facebook)
        }
        render={(renderProps) => (
          <FacebookIcon
            src={Images.FacebookWhiteIcon}
            onClick={renderProps.onClick}
          />
        )}
      />

      <GoogleLogin
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
        scope="profile email"
        onSuccess={(response) =>
          handleSocialMediaSubmit(response, loginProvider.google)
        }
        onFailure={(response) =>
          handleSocialMediaSubmit(response, loginProvider.google)
        }
        cookiePolicy="single_host_origin"
        render={(renderProps) => (
          <GoogleIcon
            src={Images.GoogleNoBackGrIcon}
            onClick={renderProps.onClick}
          />
        )}
      />
    </SocialMediaIcons>
  );
};
